var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarvelRivalsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDCFE",
    d: "M9.294 3.99H1.22l8.77 4.387-6.631-.108 5.24 5.74h8.288L8.278 9.731h6.31l-5.294-5.74z"
  })));
}
export default __webpack_public_path__ + "static/svg/marvel-rivals-logo.svg";
export { SvgMarvelRivalsLogo as ReactComponent };